module.exports = __webpack_public_path__ + "static/media/pro-8.f8a5719d.jpg";